enum TITLES {
  default = 'Vos données personnelles doivent être actualisées',
  notEmancipated = 'Comment mettre à jour vos données personnelles ?',
  adultSupportOperation = 'Vos données personnelles doivent être actualisées afin que vous puissiez réaliser un',
}

enum LOCATION_KEYS {
  dashboard = 'dashboard',
  informations = 'informations',
  versementlibre = 'versement libre',
  versement = 'versement',
  arbitrage = 'arbitrage',
  rachatRetrait = 'rachat ou un retrait',
}

enum CONTENT {
  adultDashboard = 'Nous vous prions de bien vouloir vérifier la validité de vos informations personnelles. Celles-ci conditionnent directement la qualité de notre conseil. Elles sont déclaratives et utilisées uniquement dans le cadre de la gestion de votre dossier, conformément à la réglementation en vigueur.',
  notEmancipatedContent = 'Ces informations conditionnent directement la qualité de notre conseil. Elles sont déclaratives et utilisées uniquement dans le cadre de la gestion de votre dossier, conformément à la réglementation en vigueur.',
  empty = '',
}

const URL_PDF_KYC_MINOR = 'https://placement.meilleurtaux.com/images/docs-reglementation/mise-a-jour-situation-mineur';
const URL_PDF_KYC_MAJOR = 'https://placement.meilleurtaux.com/images/docs-reglementation/mise-a-jour-situation-majeur';

export { TITLES, LOCATION_KEYS, CONTENT, URL_PDF_KYC_MINOR, URL_PDF_KYC_MAJOR };
